<template>
    <div>
        <ul>
            <li>
                <router-link to="/">
                    <div>
                        {{ $translation.L('MENU_MAINMENU') }}
                    </div>
                </router-link>
            </li>
            <li>
                <router-link to="/pracownicy">
                    <div>
                        {{ this.$translation.L('MENU_STAFF') }}
                    </div>
                </router-link>
            </li>
            <li>
                <router-link to="/seminaria">
                    <div>
                        {{ this.$translation.L('MENU_SEMMINARS') }}
                    </div>
                </router-link>
            </li>
            <li>
                <router-link to="/geneaologia">
                    <div>
                        {{ $translation.L('MENU_GENEAOLOGY') }}
                    </div>
                </router-link>
            </li>
            <li>
                <router-link to="/ksiazki">
                    <div>
                        {{ $translation.L('MENU_BOOKS') }}
                    </div>
                </router-link>
            </li>
            <li>
                <router-link to="/studenci">
                    <div>
                        {{ $translation.L('MENU_STUDENTS') }}
                    </div>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'navbar',
};
</script>

<style scoped>
* {
    user-select: none;
}
ul {
  display: inline-block;
  list-style-type: none;
}

li a div {
  padding: 20px;
  margin-top:5px;
  width: 9vw;
  text-align: center;
  margin: 0 0.15vw;
  text-decoration: none;
}

li {
    display: inline-block;
}

li a {
  font-weight: bold;
  text-decoration: none;
  color: white;
  font-size: 0.8vw;
  width: 100%;
  height: 100%;
  display: block;
  text-align: center;
}

li a div {
    transition: background-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out,
    -moz-box-shadow 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out,;
}

li a:not(.router-link-exact-active) div:hover {
    background-color: #4d5499;
    -webkit-box-shadow: 5px 5px 80px -5px rgba(0,0,0,0.75);
    -moz-box-shadow: 5px 5px 90px -5px rgba(0,0,0,0.75);
    box-shadow: 5px 5px 80px -5px rgba(0,0,0,0.75);
}


li a.router-link-exact-active {
    background-color: #4d5499;
    -webkit-box-shadow: 5px 5px 80px -5px rgba(0,0,0,0.75);
    -moz-box-shadow: 5px 5px 90px -5px rgba(0,0,0,0.75);
    box-shadow: 5px 5px 80px -5px rgba(0,0,0,0.75);
    cursor: default;
}

@media only screen and (max-width: 1023px){
    li a div{
        display:block;
        padding: 1px;
        width: 70vw;
        height: fit-content;
        border: 1px solid white;
        border-radius: 5px;
        margin: 3px 0;
    }


    li a {
        font-size: 4vw;
        text-align: center;
    }

    li a:not(.router-link-exact-active) div:hover {
        background-color: transparent;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
    }

    li a.router-link-exact-active {
        background-color: white;
        border-radius: 5px;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        color: rgb(90,105,207);
    }
}
</style>
